module.exports = __webpack_public_path__ + "img/home_img_14.4f4c9662.png";